/* eslint-disable no-dupe-class-members */
import { observable, action, autorun } from "mobx";
import jwt_decode from "jwt-decode";

class SessaoStore {
  @observable
  token = "";

  @action.bound
  setCurrent(token) {
    this.token = token;
    global.sessionStorage.setItem("omega.web.token", token);
  }

  @action.bound
  isLoggerIn() {
    return !!global.sessionStorage.getItem("omega.web.token");
  }

  @action.bound
  logout() {
    this.token = "";
    global.sessionStorage.removeItem("omega.web.token");
    return Promise.resolve(true);
  }

  @action.bound
  ifGranted(fromRoles = []) {
    if (!this.isLoggerIn()) {
      return false;
    }

    const payload = jwt_decode(global.sessionStorage.getItem("omega.web.token"));
    if (!payload.roles) {
      return false;
    }

    let roles = [];
    if (typeof payload.roles === "string") {
      roles = payload.roles.split(",");
    } else {
      roles = payload.roles.slice(0);
    }

    let from = [];
    if (typeof fromRoles === "string") {
      from = fromRoles.split(",");
    } else {
      from = fromRoles.slice(0);
    }

    return roles.filter(i => from.includes(i)).length !== 0;
  }

  get usuario() {
    const payload = jwt_decode(this.token);
    return payload;
  }
}

const store = new SessaoStore();

autorun(() => {
  store.token = global.sessionStorage.getItem("omega.web.token");
});

export default store;



// WEBPACK FOOTER //
// ./src/stores/SessaoStore.js